export default __webpack_public_path__ + "static/media/down.1d6a530c.png";